<div class="container">
  <mat-form-field>
    <mat-label>Search Movie</mat-label>
    <input matInput placeholder="Avengers" (keyup.enter)="update($event)" />
    <mat-hint>Press Enter to Search</mat-hint>
  </mat-form-field>

  <div class="sort" *ngIf="movies">
    <button mat-button [mat-menu-trigger-for]="sort">
      Sort <mat-icon>expand_more</mat-icon>
    </button>
    <mat-menu #sort="matMenu">
      <button mat-menu-item (click)="sortByRating()">Sort By Rating</button>
      <button mat-menu-item (click)="sortByRelease()">
        Sort By Release Date
      </button>
    </mat-menu>
  </div>
  <div *ngIf="movies" class="movies">
    <div *ngFor="let movie of movies.results" class="movie">
      <a [routerLink]="['/movie', movie.id]">
        <mat-card>
          <mat-card-header>
            <mat-card-title>{{ movie.title }}</mat-card-title>
            <mat-card-subtitle>
              <mat-icon aria-hidden="false" aria-label="Movie Average Rating">
                star
              </mat-icon>
              {{ movie.vote_average }}
            </mat-card-subtitle>
          </mat-card-header>
          <img
            *ngIf="movie.poster_path"
            mat-card-image
            [src]="imageURL + movie.poster_path"
            [alt]="movie.title"
          />
          <mat-card-content>
            <p>
              {{ movie.overview | slice: 0:100 }}
            </p>
          </mat-card-content>
        </mat-card>
      </a>
    </div>
  </div>
  <mat-spinner *ngIf="!movies && load"></mat-spinner>
</div>
